import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  fullName: string | null | undefined
  avatar: string | null | undefined
}

function EmployeeField({ fullName, avatar }: Props) {
  if (fullName) {
    return (
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Avatar size="s32" label={fullName} url={buildUrl(avatar)} />
        <Text.Normal>{fullName}</Text.Normal>
      </Box>
    )
  }
  return <></>
}

export default EmployeeField
